export const Page = {
    get tubDivElement()
    {
        return document.getElementById("tub") as HTMLDivElement;
    },
    get tubItemDivElement()
    {
        return document.getElementById("tubItem") as HTMLDivElement;
    },
    get fillTubButtonElement()
    {
        return document.getElementById("fillTub") as HTMLButtonElement;
    },
    get drainTubButtonElement()
    {
        return document.getElementById("drainTub") as HTMLButtonElement;
    },
    get bathBomb1ButtonElement()
    {
        return document.getElementById("bathBomb1") as HTMLButtonElement;
    },
    get bathBomb2ButtonElement()
    {
        return document.getElementById("bathBomb2") as HTMLButtonElement;
    },
    get bathBomb3ButtonElement()
    {
        return document.getElementById("bathBomb3") as HTMLButtonElement;
    },
    get unlockButtonElement()
    {
        return document.getElementById("unlockButton") as HTMLButtonElement;
    },
    get unlockSectionElement()
    {
        return document.getElementById("unlock") as HTMLElement;
    },
    get gameSectionElement()
    {
        return document.getElementById("game") as HTMLElement;
    },
    get bodyElement()
    {
        return document.getElementById("body") as HTMLBodyElement;
    },
    get messageParagraphElement()
    {
        return document.getElementById("message") as HTMLParagraphElement;
    }
};